import { Stars } from 'components/card/StarRank';

type Props = { dropRank: number };
export const DropRank = ({ dropRank }: Props) => {
  const starCount = Math.abs(dropRank - 6);
  return <Stars count={starCount} />;
};
